import { useInfiniteQuery } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'

import type { operations } from '@/schema'

type GetClosedRoomsParams =
	operations['ChatController_getClosedRooms']['parameters']['query']

export function useQueryClosedRooms(
	params?: Omit<GetClosedRoomsParams, 'start'>,
) {
	return useInfiniteQuery({
		queryKey: chatKeys.closedRooms(params),
		queryFn: ({ pageParam }) =>
			chatService.getClosedRooms({
				...params,
				start: pageParam,
			}),
		initialPageParam: undefined as string | undefined,
		getNextPageParam: (lastPage) =>
			lastPage.pagination.hasMore ? lastPage.pagination.nextCursor : undefined,
	})
}
